export const parseArgsRegExp = /'(?<name>\w+)\s*?(?<range>\[.+\])(?:\*\*(?<slope>[^=]+))?\s*?=\s*(?<value>[.0-9kKbBmsf]+)/gi

export const parseImportantIds = /(?<id>[#\w]+(:\d+,?\d*|[(=]))/gi

export function removeArgValues(code: string) {
  return code.replace(parseArgsRegExp, (arg: string) =>
    arg.split('=')[0].trim()
  )
}

export function removeArgs(code: string) {
  return code.replace(parseArgsRegExp, '')
}

export function getImportantIds(code: string) {
  return [...code.matchAll(parseImportantIds)].map((x) => `${x.groups!.id}`)
}

export function isCodeCompatible(a: string, b: string) {
  return getImportantIds(a).join() === getImportantIds(b).join()
}
